import React from 'react';
import Image from 'next/image';
import { Button, Chip, IconButton } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';

import { formatPrice } from 'utils/helpers';
import { openModal } from 'features/utilsSlice';
import useProfileOwner from 'hooks/useProfileOwner';
import Toast from 'utils/toast';
import ShareIcon from 'public/icons/share-main.svg';
import EditIcon from 'public/icons/edit-purple.svg';
import ReadMore from 'components/ReadMore';
import IconMainContainer from 'components/IconMainContainer';
import styles from 'styles/components/Wishlist.module.scss';

const WishCard = ({ wish, profile }) => {
  const { image_url, name, description, price, kind } = wish;
  const dispatch = useDispatch();
  const profileOwner = useProfileOwner(profile);

  const url = `${window.location.href}?wish=${wish.id}`;

  const handleClick = () => {
    if (!profileOwner) {
      dispatch(openModal({ name: 'Wish Checkout', data: { wish } }));
    } else {
      dispatch(openModal({ name: 'Wish Form', data: { wish, action: 'edit' } }));
    }
  };

  return (
    <div className={styles.card} onClick={handleClick}>
      <div className={styles.imgContainer}>
        <Image src={image_url} layout="fill" alt={name} unoptimized />

        {kind === 'crowdfunding' && (
          <Chip color="primary" label="Crowdfunding" className={styles.chip} />
        )}

        {profileOwner && (
          <IconButton
            onClick={() =>
              dispatch(openModal({ name: 'Wish Form', data: { wish, action: 'edit' } }))
            }
            className={styles.editIcon}
          >
            <EditIcon />
          </IconButton>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div style={{ padding: '15px 15px 0' }}>
          <div className={styles.header}>
            <h2>{name}</h2>

            <h3>{formatPrice(price)}</h3>
          </div>

          <div className={styles.description}>
            <ReadMore description={description} mobileLength={250} desktopLength={250} />
          </div>
        </div>

        <div className={styles.actions}>
          <CopyToClipboard text={url}>
            <IconButton
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                Toast('success', 'Copied wish url to clipboard!', {
                  icon: (
                    <IconMainContainer src="/icons/notifications/thumb-up.svg" alt="Thumb Up" />
                  ),
                });
              }}
            >
              <ShareIcon />
            </IconButton>
          </CopyToClipboard>

          {!profileOwner && (
            <Button
              onClick={() => dispatch(openModal({ name: 'Wish Checkout', data: { wish } }))}
              color="primary"
              variant="contained"
              className={styles.button}
            >
              Gift me
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WishCard;
